"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Communications } from "@/src/gql/graphql";
import { parseCommunicationMetadata } from "@/lib/utils/crm/communication-email-provenance";
import { CommunicationEmailProvenanceCard } from "./CommunicationEmailProvenanceCard";

export function CommunicationsMetadataDisplay({ item }: TabContentProps<Communications>) {
  const communication = item;
  const rawMetadata: unknown = communication.metadata;
  const metadataRecord = parseCommunicationMetadata(rawMetadata);
  const metadataJson =
    metadataRecord != null
      ? JSON.stringify(metadataRecord, null, 2)
      : typeof rawMetadata === "string" && rawMetadata.trim()
        ? rawMetadata
        : null;

  return (
    <div className="space-y-6">
      <CommunicationEmailProvenanceCard metadata={communication.metadata} />

      <Card>
        <CardContent className="pt-6 space-y-4 text-sm">
          <div>
            <span className="text-gray-600 dark:text-gray-400">ID:</span>
            <p className="text-gray-900 dark:text-gray-100 font-mono">{communication.id}</p>
          </div>
          <div>
            <span className="text-gray-600 dark:text-gray-400">Created:</span>
            <p className="text-gray-900 dark:text-gray-100">
              {typeof communication.created_at === "string"
                ? new Date(communication.created_at).toLocaleString()
                : "Unknown"}
            </p>
          </div>
          <div>
            <span className="text-gray-600 dark:text-gray-400">Updated:</span>
            <p className="text-gray-900 dark:text-gray-100">
              {typeof communication.updated_at === "string"
                ? new Date(communication.updated_at).toLocaleString()
                : "Unknown"}
            </p>
          </div>
          {typeof communication.external_id === "string" && communication.external_id && (
            <div>
              <span className="text-gray-600 dark:text-gray-400">External ID:</span>
              <p className="text-gray-900 dark:text-gray-100 font-mono">{communication.external_id}</p>
            </div>
          )}
        </CardContent>
      </Card>

      {metadataJson ? (
        <Card>
          <CardContent className="pt-6">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">
              Raw metadata
            </h3>
            <pre className="text-xs font-mono whitespace-pre-wrap break-all rounded-lg border border-gray-200 bg-gray-50 p-3 text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 max-h-96 overflow-auto">
              {metadataJson}
            </pre>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
}
